import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from './components/ui/sonner';
import '@/App.css';

import Home from './pages/Home';
import Login from './pages/Login';
import Register from './pages/Register';
import Browse from './pages/Browse';
import VehicleDetail from './pages/VehicleDetail';
import Wishlist from './pages/Wishlist';
import Dashboard from './pages/Dashboard';
import UploadVehicle from './pages/UploadVehicleWizard';
import EditVehicle from './pages/EditVehicle';
import AdminDashboard from './pages/AdminDashboard';
import SuperAdminDashboard from './pages/SuperAdminDashboard';
import SuperAdminManagement from './pages/SuperAdminManagement';
import AgentDashboard from './pages/AgentDashboard';
import AnalyticsDashboard from './pages/AnalyticsDashboard';
import ContactUs from './pages/ContactUs';
import SellerProfile from './pages/SellerProfile';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import PageLoader from './components/PageLoader';
import MobileBottomNav from './components/MobileButtonNav';
import ScrollToTop from './components/ScrollToTop';
import PartnerDashboard from './pages/PartnerDashboard';
import PartnerInspectPage from './pages/Partnerinspectpage';
import InfluencerDashboard from './pages/Influencerdashboard';
import ScrollToTopButton from './components/Scrolltotopbutton';
import ChatWidget from './components/ChatWidget';
import Blogs, { BlogDetail } from './pages/Blogs';
import GoogleAuthCallback from './pages/GoogleAuthCallback';
import OnboardingTour from './components/OnboardingTour';


function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
      <ScrollToTop />
        <div className="App pb-16 md:pb-0">
          <Toaster position="top-right" />
          <PageLoader />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/login" element={<Login />} />
            <Route path="/auth/google/callback" element={<GoogleAuthCallback />} />
            <Route path="/register" element={<Register />} />
            <Route path="/browse" element={<Browse />} />
            <Route path="/vehicles/:id" element={<VehicleDetail />} />
            <Route path="/seller/:id" element={<SellerProfile />} />
            <Route path="/contact" element={<ContactUs />} />
            <Route path="/wishlist" element={<ProtectedRoute><Wishlist /></ProtectedRoute>} />
            <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
            <Route path="/upload-vehicle" element={<ProtectedRoute><UploadVehicle /></ProtectedRoute>} />
            <Route path="/edit-vehicle/:vehicleId" element={<ProtectedRoute><EditVehicle /></ProtectedRoute>} />
            <Route path="/admin" element={<ProtectedRoute roles={['admin', 'superadmin']}><AdminDashboard /></ProtectedRoute>} />
            <Route path="/superadmin" element={<ProtectedRoute roles={['superadmin']}><SuperAdminDashboard /></ProtectedRoute>} />
            <Route path="/superadmin/manage" element={<ProtectedRoute roles={['superadmin']}><SuperAdminManagement /></ProtectedRoute>} />
            <Route path="/agent/dashboard" element={<ProtectedRoute roles={['agent', 'admin', 'superadmin']}><AgentDashboard /></ProtectedRoute>} />
            <Route path="/agent/bulk-upload" element={<Navigate to="/agent/dashboard" replace />} />
            <Route path="/analytics" element={<ProtectedRoute roles={['admin', 'superadmin']}><AnalyticsDashboard /></ProtectedRoute>} />
            <Route path="/partner" element={<PartnerDashboard />} />
            <Route path="/partner/inspect/:vehicleId" element={<PartnerInspectPage />} />
            <Route path="/influencer/dashboard" element={<InfluencerDashboard />} />
            <Route path="/blogs" element={<Blogs />} />
            <Route path="/blogs/:slug" element={<BlogDetail />} />
          </Routes>
          <MobileBottomNav />
          <ScrollToTopButton />
          <ChatWidget />
          <OnboardingTour />
        </div>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
